import { CSSResultArray, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { PCCarousel } from '../pc-carousel/pc-carousel';

import carouseltStyles from '../pc-carousel/pc-carousel.css.lit';
import componentStyles from './pc-story-carousel.css.lit';
import pcHeroStyles from '../pc-hero/pc-hero.css.lit';
import pcHeroLightDomStyles from '../pc-hero/pc-hero.lightDom.css.lit';
import personalQuoteStyles from '../pc-personal-quote/pc-personal-quote.css.lit';
import personalQuoteLightDomStyles from '../pc-personal-quote/pc-personal-quote.lightDom.css.lit';
import imageStyles from '../pc-image/pc-image.lightDom.css.lit';
import headingStyles from '../pc-heading/pc-heading.lightDom.css.lit';
import detailStyles from '../pc-detail/pc-detail.css.lit';
import captionStyles from '../pc-caption/pc-caption.css.lit';
import wysiwygStyles from '../pc-wysiwyg/pc-wysiwyg.lightDom.css.lit';

import '../pc-container/pc-container';

/**
 * Story Carousel component
 * @element pc-story-carousel
 * @slot - This element has a default slot
 */
@customElement('pc-story-carousel')
export class PCStoryCarousel extends PCCarousel {
  static styles: CSSResultArray = [
    carouseltStyles,
    componentStyles,
    pcHeroStyles,
    pcHeroLightDomStyles,
    personalQuoteStyles,
    personalQuoteLightDomStyles,
    imageStyles,
    headingStyles,
    detailStyles,
    captionStyles,
    wysiwygStyles,
  ];

  render(): TemplateResult {
    return html`
      <div class="carousel carousel--story">${this.carouselTemplate()}</div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-story-carousel': PCStoryCarousel;
  }
}
